import axiosClient from "./axiosClient";

// ------------------- Residents / Auth API -------------------

// Add a new resident
export const addResident = (residentData) => {
  // residentData: { full_name, email, password, phone }
  return axiosClient.post("/residents", residentData);
};

// Soft delete resident by id (sets deleted_at)
export const deleteResident = (residentId) => {
  return axiosClient.patch(`/residents/${residentId}/delete`);
};

// Update resident by id
export const updateResident = (residentId, updateData) => {
  // updateData: { full_name?, email?, password?, phone? }
  return axiosClient.patch(`/residents/${residentId}`, updateData);
};

// Update approval status
export const updateApprovalStatus = (residentId, approval) => {
  // approval: 'pending', 'approved', or 'rejected'
  const token = localStorage.getItem("token"); // Make sure JWT is stored after login
  return axiosClient.patch(
    `/residents/${residentId}/approval`,
    { approval },
    { headers: { Authorization: `Bearer ${token}` } } // Send token
  );
};

// Login
export const login = (credentials) => {
  // credentials = { email, password }
  return axiosClient.post("/residents/login", credentials);
};

// Logout
export const logout = () => axiosClient.post("/residents/logout");



// Get resident(s)
export const getResident = (residentId = null) => {
  if (residentId) {
    return axiosClient.get(`/residents/${residentId}`);
  } else {
    return axiosClient.get("/residents");
  }
};

// Get currently logged-in user
export const getLoggedInUser = () => {
  const token = localStorage.getItem("token");
  return axiosClient.get("/residents/me", {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// ------------------- Password Reset -------------------

// Send reset password email
export const sendResetEmail = ({ email }) => {
  return axiosClient.post("/residents/forgot-password", { email });
};

// Reset password with token
export const resetPassword = ({ token, password }) => {
  return axiosClient.post("/residents/reset-password", { token, password });
};
